export default {"src":"/_next/static/media/slack.1537b644.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};